import { render, staticRenderFns } from "./branchDetail.vue?vue&type=template&id=3f13f5f0&scoped=true"
import script from "./branchDetail.vue?vue&type=script&lang=js"
export * from "./branchDetail.vue?vue&type=script&lang=js"
import style0 from "./branchDetail.vue?vue&type=style&index=0&id=3f13f5f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f13f5f0",
  null
  
)

export default component.exports